import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
// import ImageMapper from 'react-img-mapper';
// import ImageMapper from '../../../../my/react-img-mapper/dist/ImageMapper';
import ImageMapper from '../rim/ImageMapper'
import { Game2Map, useStore } from '../lib'
import { Guide, Loader, ModalAlert, ScoreStats, SideNav } from '../components'
import imgFox from '../assets/game2/liska.jpg'
import imgPheasant from '../assets/game2/bazant.jpg'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { GameFrame } from './GameFrame'

export const Game2 = () => {
  const [username, setUsername] = useState<string>('')
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>(window.innerWidth * 0.57 - 2 * 16 * 2)
  const [img, setImg] = useState<any>(null)
  const [gameMap, setGameMap] = useState<any>(null)
  const [selectedArea, setSelectedArea] = useState<string>('')
  const [areas, setAreas] = useState<any[]>([])
  const [answers, setAnswers] = useState<any[]>([])
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>()
  const history = useHistory()
  const refImgMapper: any = useRef(null)
  const refGuide: any = useRef(null)
  const refModal: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()
  const variants = Object.keys(Game2Map)
  const selectGameVariant = (key?: string) => {
    const variant = Game2Map[key || variants[Math.floor(Math.random() * variants.length)]]
    setGameMap(variant)
    setAnswers(variant.details.parts)
    setAreas(variant.areas)
    switch (variant.name) {
      case 'fox':
        setImg(imgFox)
        break
      case 'pheasant':
        setImg(imgPheasant)
        break
    }
    return variant
  }
  useEffect(() => {
    setUsername(state.username)
    selectGameVariant(['fox', 'pheasant'][Math.floor(Math.random() * 2)]) // todo zvirata!
    patchState({ score: 0, errors: 0 }) // todo
    setIsInitialized(true)
    setTimeout(() => setIsInitialized(false), 50)
    setTimeout(() => setIsInitialized(true), 100)
    setTimeout(() => refGuide?.current?.openModal([Game2Map.welcome]), 101)
  }, [])

  const setAnswer = (id: string) => {
    if (id === selectedArea) {
      const answer = answers.filter(a => a.id === id)[0]
      const remainingAnswers = answers.filter(a => a.id !== id && a.isCorrect).length
      setAnswers(answers.filter(a => a.id !== id))
      setAreas(areas.filter(a => a.name !== id))
      setSelectedArea('')
      const currentScore = state.score + 1
      refGuide?.current?.openModal([answer.comment])
      if (remainingAnswers) {
        patchState({ score: currentScore })
      } else {
        const timeMs = +new Date() - gameStartTime
        patchState({
          score: currentScore,
          timeMs: state.timeMs + timeMs,
          games: { ...state.games, game2: { score: currentScore, errors: state.errors, timeMs } },
        })
        // if (variants.length - 1 > variants.indexOf(gameMap.name)) {
        //   refModal?.current?.openModal([answer.comment, `Hotovo zvire, score: ${currentScore}, errors: ${state.errors}`]);
        //   const nextVariantKey = variants[variants.indexOf(gameMap.name) + 1]
        //   selectGameVariant(nextVariantKey)
        // } else {
        //   refGuide?.current?.openModal([answer.comment, `Hotovo, score: ${currentScore}, errors: ${state.errors}`]);
        setGameEndTime(+new Date())
        refGuide.current?.playSound()
        refGuide?.current?.onGameEnd(state.errors)
        setIsFinished(true)
        // }
      }
    } else {
      refGuide?.current?.openModal(
        [gameMap.details.errorComments[Math.floor(Math.random() * (gameMap.details.errorComments.length - 1))]],
        'orange',
      )
      patchState({ errors: state.errors + 1 })
    }
  }
  const selectArea = (name?: string) => {
    setSelectedArea(name || '')
  }
  const clearSelection = () => refImgMapper.current?.clearHighlightedArea()

  const exitGame = () => {
    history.push('/dashboard')
  }

  if (!gameMap) {
    return <Loader />
  }
  return (
    <div className="view background-winter">
      <div className="p-5 text-black view-content">
        <h1 className="text-3xl text-center font-bold w-full">Myslivecká mluva</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game2Map.intro} />
        <div style={{ zIndex: 99 }}>
          <Guide ref={refGuide} isWinter={true} hasWinterGearA={true} hasWinterGearB={true} />
        </div>
        <GameFrame
          isFinished={isFinished}
          onExit={exitGame}
          childrenLeft={
            <div
              style={{ width: `${imgWidth}px`, maxWidth: `${imgWidth}px` }}
              className="flex justify-center items-center"
            >
              <ImageMapper
                containerRef={refImgMapper}
                src={img}
                map={{ name: gameMap.name, areas }}
                parentWidth={imgWidth}
                stayHighlighted={true}
                responsive={isInitialized}
                // onMouseEnter={e => console.log(e)}
                onClick={(e: any) => selectArea(e.name)}
              />
            </div>
          }
          childrenRight={
            isFinished ? null : !selectedArea?.length ? (
              <div className="card glass p-2 w-full shadow-xl">Vyber část zvířete</div>
            ) : (
              answers.map(p => (
                <button
                  key={p.id}
                  onClick={() => setAnswer(p.id)}
                  className="btn w-full glass text-black mb-5 shadow-xl"
                  disabled={!selectedArea?.length}
                >
                  {p.label}
                </button>
              ))
            )
          }
        />
        <div>
          <ModalAlert ref={refModal} onClose={() => null} />
        </div>
      </div>
    </div>
  )
}
